/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2022
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from 'carbon-components-react';
import Invoker from '../utils/invoker';
import Copier from './Copier';
import { isEmpty } from 'lodash';
import { getOauthErrorMessage } from '../utils/error-message-handler';
import classNames from 'classnames';
import { CodeViewer } from './CodeViewer';

import isEqual from 'lodash/isEqual';

export class TestToolOidcDiscovery extends Component {
  constructor(props) {
    super(props);
    this.invoker = new Invoker();
    this.discover = this.discover.bind(this);
    this.state = {
      discovery: {},
      authError: {}
    };
  }

  componentDidMount() {
    this.configure(this.props);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps, this.props)) {
      this.configure(this.props);
    }
  }

  configure(props) {
    if (props.config && props.config.discovery) {
      this.setState({ discovery: props.config.discovery });
    }
  }

  async discover() {
    let { t } = this.props;
    let openIdConnectUrl = this.props.config.flags.openIdConnectUrl;
    let newState = Object.assign(this.state);

    try {
      newState.discovery = await this.invoker.discover(openIdConnectUrl);

      newState.authError = {};
    } catch (err) {
      console.error(err.stack);
      newState.authError = await getOauthErrorMessage(err, t);
    } finally {
      this.setState(newState);
      if (this.props.onClick && typeof this.props.onClick === 'function') {
        this.props.onClick(newState);
      }
    }
  }

  render() {
    let { t } = this.props;

    let { authError } = this.state;

    return (
      <div className="testToolOauth">
        <div className="url openIdConnectUrl">
          <legend htmlFor="openIdConnectUrl" className="parameterName">
            {t('explorer_openIdConnect_url')}
          </legend>
          <p className="parameterValue">{this.props.config.flags.openIdConnectUrl}</p>
        </div>
        <div className="refreshToken">
          <Button className="oidcDiscoverButton" id="oidcDiscoverButton" onClick={this.discover}>
            {t('explorer_oidc_discover')}
          </Button>
          {authError && authError.highlightedText && (
            <div className="authError">
              <pre>
                <code className="boundedSection hljs oauthError" dangerouslySetInnerHTML={authError.highlightedText} />
              </pre>
            </div>
          )}
        </div>
        {!isEmpty(this.state.discovery) && (
          <div>
            <div className={'testResponseBody'}>
              <div className="body">
                <Copier element=".testResponseContent" />
                <div className={classNames('boundedSection testResponseContent')}>
                  <div className="contrast responseDetails responseBody">
                    <CodeViewer codeLanguage={'json'}>{JSON.stringify(this.state.discovery, null, 2)}</CodeViewer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(TestToolOidcDiscovery);
